import { Contract, ContractTenant } from '../../../../common/validations'
import { TerminationDisallowedReason } from '../../../../common/types'

export const isMoveOutDisabled = (
  contract: Contract,
  tenant: ContractTenant
) => {
  if (
    contract.terminationDisallowedReason ===
    TerminationDisallowedReason.NOT_CONTRACT_PARTY
  ) {
    return tenant.id !== contract.tenant.id
  }

  return contract.terminationDisallowedReason !== undefined
}
